module.exports = __webpack_public_path__ + "img/nicetohave-product-design-08.e0783cf8.jpg";